@let startDate = startDateSg();
@let endDate = endDateSg();
@let rangePicker = rangePickerSg();

<div class="atn-ds-date-range-input">
  <mat-date-range-input
    [rangePicker]="rangePicker"
    class="atn-ds-input-field__control atn-ds-input-field__control--date-range"
  >
    <input
      readonly
      matStartDate
      [value]="startDate"
      placeholder="BOT"
    />

    <input
      readonly
      matEndDate
      [value]="endDate"
      placeholder="EOT"
      class="atn-ds-input-field--date-range-end"
    />
  </mat-date-range-input>
</div>
